
















































import { Component, Vue, Ref } from 'vue-property-decorator';
import { roleManage } from './role';
import { timeFormat } from '@/utils/other';
import RoleModal from './components/roleModal.vue';

type IRoleInfo = IRole.IResponse.IRoleInfo;

const columns = [
  {
    slots: { title: 'nameTit' },
    dataIndex: 'name',
    // scopedSlots: { customRender: 'name'},
    width: '10%',
  },
  {
    slots: { title: 'commentTit' },
    dataIndex: 'comment',
    // scopedSlots: { customRender: 'comment'},
    width: '20%',
  },
  {
    slots: { title: 'createdNameTit' },
    dataIndex: 'createdName',
    scopedSlots: { customRender: 'createdName'},
    width: '20%',
    align: 'center',
  },
  {
    slots: { title: 'userTit' },
    dataIndex: 'user',
    scopedSlots: { customRender: 'user'},
    width: '34%',
  },
  {
    slots: { title: 'activeTit' },
    dataIndex: 'active',
    scopedSlots: { customRender: 'active'},
    width: '5%',
    align: 'center',
  },
  {
    slots: { title: 'actionTit' },
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: '11%',
    align: 'center',
  },
];

@Component({
  name: 'Role',
  filters: {
    timeFormat,
  },
  components: {
    RoleModal,
  },
})
export default class Role extends Vue {
  @Ref() private readonly roleModal!: RoleModal;
  private roleManage = roleManage;
  private columns = columns;
  private pagination = {
    hideOnSinglePage: true,
  };
  private spinning = false;
  get roleList() {
    return this.roleManage.tableData;
  }
  private created() {
    this.refreshRoles();
  }
  private destroyed() {
    roleManage.clearData();
  }
  private refreshRoles() {
    this.spinning = true;
    roleManage.requestGetRoles().then((res) => {
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private createRole() {
    roleManage.createRole();
    this.roleModal.showModal();
  }
  private editRole(role: IRoleInfo) {
    roleManage.editRole(role);
    this.roleModal.showModal();
  }
  private editUsers(role: IRoleInfo, type: 'add'| 'del') {
    roleManage.editRole(role);
    this.roleModal.showModal('edit-users', type);
  }
  private editPermissions(role: IRoleInfo, type: 'add'| 'del') {
    roleManage.editRole(role);
    this.roleModal.showModal('edit-permissions', type);
  }
  private submitDelete(roleId: string) {
    roleManage.requestDelRole(roleId).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warn(err);
    });
  }
  private handleDelRole(role: IRoleInfo) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete')}).toString(),
      onOk: () => {
        this.submitDelete(role.id);
      },
    });
  }
}
